import {useEffect, useState} from "react";
import {getBuyer, getPaymentsForBuyer} from "../../api/Api";
import {Card, Table} from 'antd';
import {Link, useParams} from "react-router";
import {toFSDate} from "../../util/timeutils";
import {PaymentStatusWidget} from "../widget/PaymentStatusWidget";


export const BuyerPaymentView = ({refresh, onRefresh, onApiFail, props}) => {
    const params = useParams();
    const {buyerId} = params;
    const [buyer, setBuyer] = useState(undefined);
    const [payments, setPayments] = useState([]);
    useEffect(() => {
        if (buyerId === undefined) {
            return;
        }
        getBuyer(buyerId).then(result => {
            setBuyer(result);
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });

        getPaymentsForBuyer(buyerId).then(result => {
            const lines = result.map(r => {
                return {
                    ...r,
                    key: r.id
                }
            }).sort((a, b) => {
                const aDate = new Date(a.timestamp);
                const bDate = new Date(b.timestamp);
                return bDate - aDate;
            })
            setPayments(lines);
        })
    }, [buyerId, refresh, onApiFail]);

    const columns = [
        {
            title: 'Date',
            dataIndex: 'timestamp',
            key: 'timestamp',
            render: (val, record, index) => {
                return toFSDate(new Date(val));
            }
        },
        {
            title: 'Payment Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (val, record, index) => {
                return `$ ${val}`
            }
        },
        {
            title: 'Invoice',
            key: 'invoice',
            dataIndex: 'invoiceNumber',
            render: (val, record) => {
                return <Link to={`/invoice/${record.invoiceId}`}>{record.invoiceNumber}</Link>
            }
        },
        {
            title: 'Recorded by',
            dataIndex: 'username',
            key: 'username'
        },
        {
            title: 'Account',
            dataIndex: 'accountName',
            key: 'accountName',
            render: (val, record, index) => {
                return val;
            }
        },
        {
            title: 'Notes',
            dataIndex: 'notes',
            key: 'notes',
        },
        {
            title: 'Status',
            dataIndex: 'state',
            key: 'state',
            render: (val) => {
                return <PaymentStatusWidget status={val}/>
            }
        }
    ];



    const tablePagination = {
        defaultPageSize: 50,
        showSizeChanger: true,
        pageSizeOptions: [50, 100, 150, 200]
    }

    const cardStyle = {
        textAlign: 'left',
        margin: '5px'
    }

    return <div>
        {buyer && <Card style={cardStyle} size={'small'} title={<b>Buyer</b>}>
            <div>{buyer.firstname} {buyer.lastname}</div>
            <div>{buyer.company}</div>
            <div>{buyer.license}</div>
        </Card>
        }

        <Card style={cardStyle} size={'small'} title={<b>Payments</b>}>
            <Table columns={columns} dataSource={payments} pagination={tablePagination} />
        </Card>
    </div>
}